import { Injectable } from '@angular/core';
import { CognitoIdentityServiceProvider } from 'aws-sdk';
import { Organization } from '../types/organization';
import { IdToken } from '../types/token';
import { User } from '../types/user';
import { Application } from '../types/application';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly DEVICE_KEY = 'uuxDevice_';

  constructor() {}

  setDeviceKey(username: string, deviceKey: string) {
    localStorage.setItem(this.DEVICE_KEY + username, deviceKey);
  }

  getDeviceKey(username: string): string {
    return localStorage.getItem(this.DEVICE_KEY + username);
  }
}
